import { render, staticRenderFns } from "./en-faq.vue?vue&type=template&id=e77c80d8&"
import script from "./en-faq.vue?vue&type=script&lang=js&"
export * from "./en-faq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports